import { Component, OnInit } from '@angular/core';
import { MetaService } from 'services/meta.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Location, LocationService } from 'services/location.service';
import { ValidationService } from 'services/validation.service';

@Component({
	selector: 'ras-refer-a-friend-page',
	templateUrl: './refer-a-friend-page.component.html',
	styleUrls: ['./refer-a-friend-page.component.sass']
})
export class ReferAFriendPageComponent implements OnInit {

	public location = null
	public name
	public surname
	public unit_number
	public friend_name
	public friend_surname
	public friend_cell
	public friend_email

	public locations: Location[]
	public busy = false
	public form_sent = false
	public form_error = false
	public show_invalid = false

	constructor(private http: HttpClient, private locationService: LocationService, public valid: ValidationService, private metaService: MetaService) { }

	ngOnInit(): void {
		this.metaService.apply('refer')

		this.locationService.get_all()
		.then(locations => {this.locations = locations})
	}

	send_message() {

		if (!this.location || !this.valid.sa_cell_number(this.friend_cell) || !this.valid.email(this.friend_email)) {

			this.show_invalid = true

		} else {

			this.busy = true

			if ((<any>window).dataLayer) (<any>window).dataLayer.push({
				'event': 'formSubmission',
				'formType': 'Refer a friend',
				'formId': 'refer'
			});

			try {
				this.http.post(
					'https://rentastore.co.za/backend/refer/',
					{
						site_id: this.location.id,
						name: this.name,
						surname: this.surname,
						unit: this.unit_number,
						friend_name: this.friend_name,
						friend_surname: this.friend_surname,
						friend_cell: this.friend_cell,
						friend_email: this.friend_email,
					},
					{
						responseType: 'text',
					}
				)
				.toPromise()
				.then(result => {
					this.busy = false
					this.form_sent = true
					this.name = ''
					this.surname = ''
					this.unit_number = ''
					this.friend_name = ''
					this.friend_surname = ''
					this.friend_cell = ''
					this.friend_email = ''
				}, reason => {
					this.form_error = true
					this.busy = false
				})
			} catch (exception) {
				this.form_error = true
				this.busy = false
				console.log(exception)
			}

		}
	}

}
